import React from 'react';
import { useApp } from '../context/AppContext';

// A thin bar across the top when the phone has no signal.
//
// Worth having because the app now keeps working offline — jobs and threads
// still open from cache — and an app that looks entirely normal while showing
// data from twenty minutes ago is how someone drives to the wrong address.
// Saying "offline" is the difference between cached and wrong.
export default function OfflineBar() {
  const { isOffline } = useApp();
  if (!isOffline) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500,
        background: 'var(--navy)', color: 'var(--white)',
        fontSize: 12.5, textAlign: 'center', padding: '6px 12px',
        letterSpacing: '.02em',
      }}
    >
      No signal — showing what was last loaded. Messages will not send.
    </div>
  );
}
